const VIDEO_TYPES = {
  YOUTUBE: 'YouTube',
  VIMEO: 'Vimeo',
};

export { VIDEO_TYPES };
